import { Dispatch, SetStateAction } from 'react'

export enum CourseStatusEnum {
  failed,
  pass,
  in_progress,
  results,
}

export type QuizStateType =
  | { status: CourseStatusEnum.pass | CourseStatusEnum.failed; percentage: number }
  | { status: CourseStatusEnum.in_progress | CourseStatusEnum.results; percentage?: never }

export interface CourseQuizStateContextInterface {
  quizState: QuizStateType | null
  setQuizState: Dispatch<SetStateAction<QuizStateType | null>>
}
